export default function PrivacyPolicy() {
	return (
		<iframe
			src="https://www.hemiteams.ai/privacy-policy"
			title="Privacy Policy"
			className="w-full h-full aspect-square"
		/>
	);
}
